// Sorting for the Finalize page's two tables (the batch plan and the result): Client and Batch Group
// only, defaulting to Client then Batch Group. Rows without a batch group sort after the grouped
// ones within a client.
const text = (value) => (value || "").toString().toLowerCase()
const groupKey = (row) => (row.batch_group_name ? `0${text(row.batch_group_name)}` : "1")

export const byClientThenGroup = (a, b) =>
    text(a.client_name).localeCompare(text(b.client_name)) || groupKey(a).localeCompare(groupKey(b))

export const byGroupThenClient = (a, b) =>
    groupKey(a).localeCompare(groupKey(b)) || text(a.client_name).localeCompare(text(b.client_name))
